// extracted by mini-css-extract-plugin
module.exports = {"btn":"style__btn__hIXy5","moveOver":"style__moveOver__YokI+","center":"style__center__V-Qtf","pageMargin":"style__pageMargin__eQUjo"};